import SectionHeader from "./SectionHeader";

const nodes = [
  {
    date: "08-28",
    tag: "发酵起点",
    tagCls: "bg-accent-100 text-accent-900",
    title: "「反差黑料主角是谁」首次被集中追问",
    text: "一条高赞评论质疑「幕布」对某话题的「科普」与其私下行为不符，迅速带动「反差黑料扒皮」话题开始传播，多人开始整理其过往发言截图。",
    tags: ["#首条评论", "#话题起量"],
  },
  {
    date: "08-31",
    tag: "证据出现",
    tagCls: "bg-primary-100 text-primary-800",
    title: "当事人 A 抛出分工聊天记录",
    text: "前合作方「L」发布 6 组聊天记录，指认「幕布」对外独占合作成果、对内口径不同，当事人之间的身份关系首次被摆上桌面。",
    tags: ["#聊天记录", "#指认分工"],
  },
  {
    date: "09-02",
    tag: "口径分化",
    tagCls: "bg-secondary-100 text-secondary-900",
    title: "关联账号「对照相」加入澄清",
    text: "被指与「幕布」同属账号矩阵的另一当事人简短澄清账号归属，但未提供佐证，事件核心人物的身份疑点进一步扩大而非收敛。",
    tags: ["#澄清", "#身份归属"],
  },
  {
    date: "09-04",
    tag: "关系补全",
    tagCls: "bg-accent-100 text-accent-900",
    title: "网友补出账号矩阵关系线",
    text: "社区侧整理出「幕布」「对照相」等账号的相似文案结构与发布时间线，推测关系但缺乏决定性证据，关于「反差黑料是谁」的多套猜想并存。",
    tags: ["#账号矩阵", "#关系猜想"],
  },
  {
    date: "09-06",
    tag: "持续追踪",
    tagCls: "bg-primary-100 text-primary-800",
    title: "本页更新：仍在等待第三方核验",
    text: "截至本页更新，主角与当事人均未出具可供独立核验的完整材料，疑点核查表中的多数条目停留在「待证」状态。",
    tags: ["#待第三方核验", "#本页更新"],
  },
];

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeader
              kicker="PART 02 · 扒皮过程"
              title="沿时间线看反差黑料扒皮怎么发生"
              desc="把散落各处的公开信息按时间归位。与其急着站队，不如先看清每个节点发生了什么、谁在何时说了什么。"
            />
            <div className="hidden lg:block rounded-xl border border-background-200 bg-background-50 p-5">
              <p className="text-sm font-medium text-foreground-900 mb-3 inline-flex items-center gap-2">
                <i className="ri-chat-history-line text-primary-600 w-5 h-5 flex items-center justify-center" />
                阅读建议
              </p>
              <ul className="space-y-2.5 text-sm leading-6 text-foreground-600 list-none">
                {["先读人物画像建立坐标", "再按时间线比对口径前后", "最后回到疑点表看哪些仍待证"].map((s) => (
                  <li key={s} className="flex gap-2">
                    <i className="ri-checkbox-circle-line text-accent-600 w-4 h-4 flex items-center justify-center mt-0.5 shrink-0" />
                    {s}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 ml-2">
              {nodes.map((n) => (
                <li key={n.date} className="mb-8 pl-6 md:pl-8 relative">
                  <span className="absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-50" />
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                    <span className="font-heading text-sm text-foreground-400">{n.date}</span>
                    <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${n.tagCls}`}>{n.tag}</span>
                  </div>
                  <h3 className="mt-1.5 text-base md:text-lg font-semibold text-foreground-950 font-heading">
                    {n.title}
                  </h3>
                  <p className="mt-2 text-sm leading-7 text-foreground-600 max-w-3xl">{n.text}</p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {n.tags.map((t) => (
                      <span key={t} className="inline-flex items-center rounded-full bg-background-50 border border-background-200 px-2.5 py-1 text-xs text-secondary-800">
                        {t}
                      </span>
                    ))}
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}